export default __webpack_public_path__ + "static/media/Food_11.ac5c1343.png";